import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  success: false ,
  msg:'',
  result: [],
  exportresult: [],
  listresult:[],
  listsuccess:false,
  total_count: 0,
  page: 1,

});

export default function productReducer(state = initState, action) {
 // console.log('action',action);
  switch (action.type) {
  case actions.PRODUCT_LIST:
   return state.set('info', action.payload.info);
  case actions.PRODUCT_LIST_RESULT:
  return state
    .set('exportresult', action.result)
    .set('result', action.result)
    .set('success', action.success)
    .set('total_count', action.total_count)
    .set('page', action.page);
  case actions.PRODUCT_FETCH_LIST_ID:
  return state
   .set('result', action.result)
   .set('success', action.success);
  //  case actions.ITEM_EDIT_SUCCESS:
  // return state
  //  .set('msg', action.msg)
  //  .set('success', action.success);
    default:
      return state;
  }
  //return state;
}
